export const MAIN_ADMINISTRATOR = "MAIN_ADMINISTRATOR";
export const CLIENT_ADMINISTRATOR = "CLIENT_ADMINISTRATOR";
